import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import usePackagingCodesList from "./hooks/usePackagingCodesList";

const PackagingCodesList = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData = null,
}) => {
  const packagingCodesListData = usePackagingCodesList(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={packagingCodesListData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {packagingCodesListData.screen_title} -{" "}
          <span className="heading-cod">
            {packagingCodesListData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={packagingCodesListData.formFields}
        dropdownValues={packagingCodesListData.dropdownValues}
        paramsData={packagingCodesListData.paramsData}
        updataParamData={packagingCodesListData.updateParamData}
      />
      <ButtonsSection ctaButtons={packagingCodesListData.ctaButtons} />
      <DisplayTable
        data={packagingCodesListData.data}
        parmKey={packagingCodesListData.parmKey}
        menuOptions={packagingCodesListData.menuOptions}
        tableHeaders={packagingCodesListData.columnDef}
        setRowData={packagingCodesListData.setRowData}
        selectedPriceSchedules={packagingCodesListData.selectedRows}
        setSelectedPriceSchedules={packagingCodesListData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={packagingCodesListData.first}
          rows={packagingCodesListData.rows}
          totalRecords={packagingCodesListData.totalRecords}
          currentPage={packagingCodesListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={packagingCodesListData.onPageChange}
        />
      </div>
      {packagingCodesListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={packagingCodesListData.isConfirmationModalOpen}
          onRequestClose={packagingCodesListData.closeConfirmationModal}
          onBack={packagingCodesListData.closeConfirmationModal}
          onSave={packagingCodesListData.deleteDosageForm}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={packagingCodesListData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default PackagingCodesList;
